import React, { useEffect, useState, useCallback } from 'react';

import { createStyles, fade, makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import cx from 'classnames';

import { colorsPalette } from '../../theme';
import useVerse from '../../utils/hooks/useVerse';
import { VideoPlayer } from '../VideoPlayer';

const useStyles = makeStyles(() =>
  createStyles({
    videoPlayer: {
      width: '100%',
      height: '100%',
    },
    modalContent: {
      top: 0,
      left: 0,
      transform: 'none',
      width: '100vw',
      height: '100vh',
    },
    container: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: '80vw',
      height: 'calc(70vh + 35px)',
      paddingTop: 35,
    },
    content: {
      borderRadius: 5,
      width: '100%',
      height: '100%',
      textAlign: 'center',
    },
    closeBtn: {
      position: 'absolute',
      top: 30,
      right: 40,
      cursor: 'pointer',
      zIndex: 20,
    },
    outsideCloseBtn: {
      padding: 3,
      width: 30,
      height: 30,
      borderRadius: '50%',
      background: fade(colorsPalette.white, 0.33),
      top: 0,
      right: 0,
    },
  }),
);

const VideoModal = ({ verseId, url = '', bumperUrl, duration, title, expertName, closeModal }) => {
  const classes = useStyles();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { onVideoClose } = useVerse();

  const closeModalHandler = () => {
    onVideoClose();
    closeModal();
  };

  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === 'Escape') {
        onVideoClose();
        closeModal();
      }
    };

    if (typeof document !== 'undefined') {
      document.body.addEventListener('keydown', escHandler, false);

      return () => document.body.removeEventListener('keydown', escHandler, false);
    }
  }, [onVideoClose, closeModal]);

  const onToggleFullscreen = useCallback((isFullscreen) => {
    setIsFullScreen(isFullscreen);
  }, []);

  return (
    <div className={classes.container}>
      <div className={cx(classes.content, isFullScreen ? classes.modalContent : '')}>
        <div
          className={cx(classes.closeBtn, 'close-btn', classes.outsideCloseBtn)}
          onClick={closeModalHandler}
        >
          <CloseIcon style={{ color: colorsPalette.white }} />
        </div>
        <VideoPlayer
          className={classes.videoPlayer}
          verseId={verseId}
          videoUrl={url}
          bumperVideoUrl={bumperUrl}
          isModal
          duration={duration}
          title={title}
          expertName={expertName}
          onToggleFullscreen={onToggleFullscreen}
          isFullScreen={isFullScreen}
        />
      </div>
    </div>
  );
};

export default VideoModal;
